<script setup lang="ts">
import { helpApps } from '~/data/apps';

const props = defineProps<{
	page: any;
}>();

const apps = ref(helpApps);

const route = useRoute();
const activeApp = computed(() => {
	const segments = (route.path || '/').split('/').filter(Boolean);
	const currentId = segments[0] || '';
	return apps.value.find((a: any) => a.id === currentId) || apps.value[0];
});
</script>

<template>
	<article class="article-details">
		<div class="article-details__header">
			<span class="c:basic-600 fs:12" v-if="props.page.date && props.page.isArticle">Last updated: {{ formatDate(props.page.date) }}</span>
			<h1 class="h3">
				{{ props.page.title }}
			</h1>
		</div>

		<ContentRenderer class="editorial" :value="page" />

		<div class="article-details__footer" v-if="activeApp">
			<HmButton
				label="Return"
				:to="`/${activeApp.id}`"
				icon="arrow-left"
				icon-position="start"
				severity="basic"
			/>
		</div>
	</article>
</template>

<style lang="scss">
@layer components
{
	.article-details
	{
		@include flex(null, null, 40);
		flex-direction:column;

		&__header
		{
			@include flex(null, null, 16);
			flex-direction:column;
		}
		&__footer
		{
			border-block-start:1px solid var(--bg-basic-200);
			padding-block-start:$spacing-sm;
		}
	}
}
</style>
